import { post } from "@/stores/dataManager/axios/axiosIndex";
import { axiosType } from "../../dataStore/memoryStore/const/constIndex"
import { getConfigFromWindowBrowser } from "@/utilities/utils";
import { ENV } from "@/utilities/EWindow";

const API = getConfigFromWindowBrowser(ENV.BASE_URL) ?? ''


const apiType = axiosType.CLIENT

const TransactionService = {
    sellCopyPortfoliosStuck(params: { config: {}; body: { accountId: string, dataForPost: any, dataVerify: any } }) {
        // sellCopyPortfoliosStuck(params: { config: {}; body: { accountId: string, masterAccount: string, amount: number, linkAccount: string } }) {
        const { body } = params
        const cvBody = {
            portfolios: body?.dataForPost ?? {}
        }
        const authBody = {
            ...cvBody,
            ...body?.dataVerify
        }
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/api/followers/accounts/${body?.accountId ?? null}/sell-copy-portfolios-stuck`, authBody, config);
    },

    sellCopyPortfoliosOddLot(params: { config: {}; body: { accountId: string, dataForPost: any, dataVerify: any } }) {
        // sellCopyPortfoliosStuck(params: { config: {}; body: { accountId: string, masterAccount: string, amount: number, linkAccount: string } }) {
        const { body } = params
        const cvBody = {
            portfolios: body?.dataForPost ?? {}
        }
        const authBody = {
            ...cvBody,
            ...body?.dataVerify
        }
        const config: any = params?.config
        return post(apiType, `${API}/cosapi/api/followers/accounts/${body?.accountId ?? null}/sell-copy-fractional-shares`, authBody, config);
    },

};

export default TransactionService;